import { Injectable } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { RequestPurposeType } from "../../shared/services/request-purpose.service";

@Injectable()
export class ExperimentDetailsShowHideService {
    private experimentDetailsFormGroup: FormGroup;
    private get seedPacketDate(): FormControl { return this.experimentDetailsFormGroup.get("seedPacketDate") as FormControl };
    
    constructor() {}

    public updateView(formGroup: FormGroup, requestPurpose: number) {
        this.experimentDetailsFormGroup = formGroup;       
        this.enableAllDisabledFields();

        switch(requestPurpose) {
            case RequestPurposeType.BiomassInFlats: {
                this.biomassInFlats();
                break;
            }
            case RequestPurposeType.BiomassInPots: {
                this.biomassInPots();
                break;
            }
            case RequestPurposeType.PollinationAndImmatureHarvest: {
                this.pollinationAndImmatureHarvest();
                break;
            }
            default: {
                break;
            }
        }

        this.experimentDetailsFormGroup.updateValueAndValidity();
    }

    private biomassInFlats(){
        this.disableHarvestedSeedAvailableInPacketDate();
    }

    private biomassInPots(){
        this.disableHarvestedSeedAvailableInPacketDate();
    }

    private pollinationAndImmatureHarvest(){
        this.disableHarvestedSeedAvailableInPacketDate();
    }

    private disableHarvestedSeedAvailableInPacketDate() {
        this.seedPacketDate.disable();
    }

    private enableAllDisabledFields() {
        this.seedPacketDate.enable();
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/services/experiment-details-show-hide.service.ts